export default __webpack_public_path__ + "static/media/seven_of_swords.7a3d156d.png";